<template>
    <div class="charts_el" ref="chartsEl"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'GjkcH5BarCharts',

    data() {
        return {

        };
    },

    mounted() {
        // this.initCharts();
    },

    methods: {
        initCharts(mockData) {
    var chartDom = this.$refs.chartsEl;
    this.myChart = echarts.init(chartDom);
    var option;

    // 渐变色
    var color = [
        { offset: 0, color: '#13D6AA' },
        { offset: 0.6, color: '#13D6AA' },
        { offset: 0.95, color: '#13D6AA' },
        { offset: 1, color: '#13D6AA' }
    ];

    // 圆环宽度
    const barMaxWidth = 10

    // 坐标轴
    const angleAxis = {
        show: false,
        max: 100 * 360 / 270,
        type: 'value',
        startAngle: 225,
        splitLine: { show: false }
    }

    // 坐标轴
    const radiusAxis = {
        show: false,
        type: 'category',
    }

    //圆环位置和大小
    const polar = {
        center: ['50%', '50%'],
        radius: '155%'
    }
    
    const series = [{
        type: 'bar',
        data: [{
            //上层圆环，显示数据
            value: mockData.value,
            itemStyle: {
                color: { type: 'linear', x: 0, y: 0, x2: 1, y2: 0, colorStops: color, },
            },
        }],
        label: {
            show: false, // 隐藏原来的 label
        },
        barGap: '-100%',
        coordinateSystem: 'polar',
        roundCap: true,
        z: 2
    },
    {
        type: 'bar',
        data: [{
            value: 100,
            itemStyle: { color: '#F7F8FA' }
        }],
        barGap: '-100%',
        coordinateSystem: 'polar',
        roundCap: true,
        z: 1
    }]
    
    // 使用单个 graphic 元素和富文本样式
    option = { 
        barMaxWidth, 
        radiusAxis, 
        polar, 
        angleAxis, 
        series,
        graphic: {
            elements: [
                {
                    type: 'text',
                    left: 'center',
                    top: '35%',
                    style: {
                        text: mockData.name,
                        fontSize: 15,
                        fill: '#333',
                        textAlign: 'center'
                    }
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '50%',
                    style: {
                        // 使用富文本样式将数字和"分"放在一起
                        text: `{value|${mockData.value}}{unit|分}`,
                        fontSize: 30,
                        textAlign: 'center',
                        rich: {
                            value: {
                                fontSize: 30,
                                fill: '#13D6AA',
                                fontWeight: 'bold',
                                fontFamily: 'Arial, sans-serif'
                            },
                            unit: {
                                fontSize: 12,
                                fill: '#13D6AA',
                                // 调整单位的位置，使其与数字底部对齐
                                verticalAlign: 'bottom',
                                // 左边距约等于两个字符的宽度
                                padding: [0, 0, 8, 8] // 上、右、下、左
                            }
                        }
                    }
                }
            ]
        }
    };

    option && this.myChart.setOption(option);
}
    },
};
</script>

<style lang="scss" scoped>
.charts_el {
    width: 100%;
    height: 100%;
    position: relative;
}
</style>